// Code-based route tree. `packages/web/` uses TanStack Router's code-based
// composition so we don't depend on a generator step or a file-system
// plugin — the route files export route objects, this module wires them
// together, and `main.tsx` hands the `routeTree` to `createRouter`.

import { rootRoute } from './routes/__root';
import { sitesListRoute } from './routes/index';
import { siteDetailRoute } from './routes/sites.$siteId';
import { crawlDetailRoute } from './routes/crawls.$crawlId';
import { crawlLineageRoute } from './routes/crawls.$crawlId.graph';
import { crawlDataSharingRoute } from './routes/crawls.$crawlId.data-sharing';
import { siteDiffLatestRoute, siteDiffPairRoute } from './routes/sites.$siteId.diff';
import { siteBaselineRoute } from './routes/sites.$siteId.baseline';
import { siteAlertsRoute } from './routes/sites.$siteId.alerts';
import { siteDataFlowsRoute } from './routes/sites.$siteId.data-flows';
import { harnessIndexRoute, harnessCoverageRoute } from './routes/harness';
import { adminObservabilityOverviewRoute } from './routes/admin.observability';
import { adminObservabilityQueuesRoute } from './routes/admin.observability.queues';
import { adminObservabilityDependenciesRoute } from './routes/admin.observability.dependencies';
import { adminObservabilityCapacityRoute } from './routes/admin.observability.capacity';
import { adminObservabilityEventsRoute } from './routes/admin.observability.events';
import { adminObservabilityCostsRoute } from './routes/admin.observability.costs';

export const routeTree = rootRoute.addChildren([
  sitesListRoute,
  siteDetailRoute,
  crawlDetailRoute,
  crawlLineageRoute,
  crawlDataSharingRoute,
  siteDiffLatestRoute,
  siteDiffPairRoute,
  siteBaselineRoute,
  siteAlertsRoute,
  siteDataFlowsRoute,
  harnessIndexRoute,
  harnessCoverageRoute,
  adminObservabilityOverviewRoute,
  adminObservabilityQueuesRoute,
  adminObservabilityDependenciesRoute,
  adminObservabilityCapacityRoute,
  adminObservabilityEventsRoute,
  adminObservabilityCostsRoute,
]);
